import React, { useContext } from 'react'

import { useCloseModal } from '../../components/modals/ModalsContext'

export const NavigationContext = React.createContext(() => () => {})
export const NavigationProvider = NavigationContext.Provider

export const useNavigation = () => useContext(NavigationContext)()

export const useNavigationWithModalCloser = () => {
  const navigate = useNavigation()
  const closeModal = useCloseModal()

  return (...params) => {
    navigate(...params)
    closeModal()
  }
}
